// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const socialProviders = require('client-v2/common/containers/auth-modal/providers')
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const routerActions = require('client-v2/common/state/router/actions')
const tag = require('client-v2/common/utils/hyperscript')

// Action dispatchers

function maybeShowErrorAlert(queryParams) {
  return function (dispatch) {
    const { error, provider } = queryParams
    if (error) {
      const providerName = socialProviders.getName(provider)
      let message = 'Please try again.'
      if (error === 'permission') {
        message = 'Please make sure you are logged-in to your social account, then try again.'
      }
      // Show alert modal on error
      dispatch(confirmModalActions.alert({
        heading: `There was a problem connecting with your ${providerName} account`,
        subheading: tag([
          message,
          '\n',
          'If you continue to have this problem, ',
          tag('a', {
            href: 'mailto:support@mix.com'
          },
            'contact support.'
          )
        ])
      }))
      dispatch(sanitizeLoginQueryParams())
    }
  }
}

function sanitizeLoginQueryParams() {
  return function (dispatch, getState) {
    const { pathname } = getState().router.location
    if (pathname === '/login') {
      // Remove error query parameters from login URL
      dispatch(routerActions.replace({ path: '/login' }))
    }
  }
}

function socialAuth(provider) {
  return async function (dispatch, getState) {
    // Wait for tracking before navigating away from page
    await businessEvents.trackSegment('social-auth', {
      authContext: 'lohp-v2',
      provider
    })
    const { pathname, search } = getState().router.location
    const r = encodeURIComponent(pathname + search)
    const href = `/auth/${provider}?r=${r}`
    dispatch(routerActions.navigate({ href }))
  }
}

function trackAppDownload(platform) {
  return async function () {
    await businessEvents.trackSegment('app-download', { platform })
  }
}

module.exports = {
  // Action dispatchers
  maybeShowErrorAlert,
  sanitizeLoginQueryParams,
  socialAuth,
  trackAppDownload
}
